export default {
  name: {
    id: 'rm_metal_indium_name',
    defaultMessage: 'Indium',
  },
  smartphoneLabel: {
    id: 'rm_metal_indium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_indium_what_it_does',
    defaultMessage:
      'Indium tin oxide (ITO) is a transparent conductive coating that detects where you touch a touchscreen. It also enables the blue light emission in LEDs, allowing displays to produce full-color images.',
  },
  extractionText1: {
    id: 'rm_metal_indium_extraction_p1',
    defaultMessage:
      'Indium has no dedicated ore deposits and is recovered mainly as a by-product of zinc smelting. Zinc ore is extracted through open-pit or underground mining and then processed at high temperatures. Indium becomes concentrated in the remaining residues and can be recovered through a kiln process that produces indium oxide dust. Only about 35% of zinc refineries worldwide are equipped to recover it, so large quantities are lost each year.',
  },
  quickFactText: {
    id: 'rm_metal_indium_quick_fact',
    defaultMessage:
      'Indium is recyclable from every screen in existence but 0% is currently recovered.',
  },
  envSummaryText: {
    id: 'rm_metal_indium_env_summary',
    defaultMessage:
      'Indium’s environmental footprint is inherited from zinc smelting, the industrial process from which it is recovered as a by-product. One of the most pressing environmental failures, however, occurs not during extraction but at end-of-life: ITO (indium tin oxide), the transparent coating used on touchscreens, is technically recoverable but is not recycled at scale. Every discarded screen drives demand for new primary extraction.',
  },
  envWaterText: {
    id: 'rm_metal_indium_env_water_text',
    defaultMessage:
      'Zinc ore naturally contains cadmium, lead and arsenic as geological impurities. When smelted at high temperatures, these are released into surrounding environments. Acidic wastewater and heavy metal contamination from smelting facilities can enter river systems and groundwater, where they persist for decades. Globally, 23 million people, 6 million livestock and 66,000 km2 of irrigated land are directly exposed to dangerous concentrations of toxic waste accumulating in riverbanks due to overall metal mining activity.',
  },
  envSoilText: {
    id: 'rm_metal_indium_env_soil_text',
    defaultMessage:
      'Because zinc ore naturally contains cadmium, lead and arsenic as geological impurities, smelting releases heavy metal particulates that settle in surrounding soils and remain indefinitely, accumulating in agricultural land and entering the food chain through crops and drinking water. This pattern has been documented in zinc-producing regions globally.',
  },
  envBiodiversityText: {
    id: 'rm_metal_indium_env_biodiversity_text',
    defaultMessage:
      'Open-pit and underground metal mining, including zinc extraction, destroys habitat and fragments ecosystems when operations encroach on pristine areas. As a sulfide ore, zinc generates acid mine drainage: highly acidic, toxic runoff that contaminates soil and groundwater for many kilometres. Without proper rehabilitation, abandoned mines remain a source of contamination for hundreds of years.',
  },
  envClimateText: {
    id: 'rm_metal_indium_env_climate_text',
    defaultMessage:
      'No specific data documenting the climate impact of indium extraction and refining has been found. Globally, mineral and metal production accounts for about 10% of total energy-related greenhouse gas emissions.',
  },
  humanSummaryText: {
    id: 'rm_metal_indium_human_summary',
    defaultMessage:
      "Indium's human impacts are inherited from zinc smelting. Communities near smelting facilities face heavy metal contamination of air, water and soil. ITO (indium tin oxide) manufacturing workers, who handle indium compounds to produce the touchscreen coating on every display, face a documented and potentially fatal occupational lung disease. Both groups operate in industries where regulatory oversight is limited and health risks are poorly monitored.",
  },
  humanDisplacementText: {
    id: 'rm_metal_indium_human_displacement_text',
    defaultMessage:
      'Zinc mining and smelting operations can displace communities when expanding facilities encroach on agricultural or grazing land. Pollution from smelting can destroy livelihoods by contaminating soil and water, effectively forcing communities off their land. Governance frameworks in major zinc-producing countries provide varying levels of protection for affected communities, and people harmed by mining often have limited access to governmental support.',
  },
  humanWaterText: {
    id: 'rm_metal_indium_human_water_text',
    defaultMessage:
      'Zinc smelting generates acidic wastewater and heavy metal contamination that can enter river systems and groundwater used by downstream communities. Where treatment infrastructure is inadequate, communities lose access to safe drinking water and fishing grounds. These impacts are documented in zinc production regions, but accountability mechanisms for affected communities remain weak.',
  },
  humanHealthText: {
    id: 'rm_metal_indium_human_health_text',
    defaultMessage:
      'Workers who manufacture the indium coating used in touchscreens face documented risk of indium lung disease, a potentially fatal condition where lung tissue is irreversibly damaged by indium compounds. A 2022 peer-reviewed study confirmed lung damage even at exposure levels previously considered safe, and called for stricter occupational health standards. Zinc smelting communities also face elevated exposure to cadmium, lead and arsenic emissions.',
  },
  humanLegalText: {
    id: 'rm_metal_indium_human_legal_text',
    defaultMessage:
      'Zinc smelting communities in major producing countries often lack effective legal mechanisms to hold companies or governments accountable for environmental and health impacts. Due diligence frameworks for critical raw materials remain poorly enforced, leaving communities with limited recourse. For ITO manufacturing workers, indium lung disease remains under-regulated: no international occupational exposure standard for indium compounds has been established so far.',
  },
  geoSummaryText: {
    id: 'rm_metal_indium_geo_summary',
    defaultMessage:
      'Indium faces a dual concentration risk. At the mining stage, China accounts for around 33% of global zinc production. Because indium is recovered as a by-product of zinc, its supply is concentrated from the outset. At the refining stage, the concentration is even greater: China produces around 70% of the world’s refined indium, while Asia as a whole accounts for more than 85%. Indium is not traded on a major exchange; prices are set through private bilateral transactions, making them difficult to monitor and potentially vulnerable to manipulation.',
  },
  geoDugText: {
    id: 'rm_metal_indium_geo_dug_text',
    defaultMessage:
      'Indium has no dedicated mining operations. As a byproduct of zinc, its mining geographic footprint mirrors zinc production: China leads with 33.3% of zinc mining, followed by Peru (10.8%), Australia (9.2%), USA (6.3%) and Mexico (5.8%), for a global total of approximately 12,000 tonnes. Only 35% of zinc refineries worldwide are equipped to recover indium, meaning indium production is even more concentrated than the underlying zinc figures suggest.',
  },
  geoProcessedText: {
    id: 'rm_metal_indium_geo_processed_text',
    defaultMessage:
      'China processes about 70% of global refined indium output. South Korea (~16%) and Japan (~6%) are the only other significant processors, followed by Canada (~4%) and France (~2%), for a global refined total of approximately 1,080 tonnes. Overall, Asia controls more than 85% of metallurgical production.',
  },
  geoLeverageText: {
    id: 'rm_metal_indium_geo_leverage_text',
    defaultMessage:
      'China announced export controls on indium-related items in February 2025, alongside bismuth, tungsten, tellurium and molybdenum. Markets had largely anticipated this move, and the price increase following the announcement was modest compared to the gallium shock of 2023.',
  },
  supplySummaryText: {
    id: 'rm_metal_indium_supply_summary',
    defaultMessage:
      "Indium's supply is structurally constrained: it only exists as a byproduct of zinc refining and cannot scale independently of zinc production. When indium demand rises, supply cannot respond on its own. China accounts for around 70% of global production and enacted export controls in February 2025. In 2024, the indium price jumped 42% in a matter of months, a signal of how fragile this supply chain is.",
  },
  supplyReservesText: {
    id: 'rm_metal_indium_supply_reserves_text',
    defaultMessage:
      'No official reserve figure exists for indium, it is never mined directly. It exists only in trace amounts inside zinc ore, making resource estimation inherently uncertain. World production sits at approximately 1,080 tonnes per year. No depletion timeline can be confirmed by institutional sources: the real constraint is the pace of zinc mining and the refining infrastructure around it.',
  },
  supplyDemandText: {
    id: 'rm_metal_indium_supply_demand_text',
    defaultMessage:
      'Most demand for indium is driven by the digital sector, mainly screens and touchscreens, making future demand highly dependent on how we use technology. Demand could fall sharply if we use fewer devices and share them more, or surge if screens multiply across everyday life. In addition, clean-energy demand for indium is projected to grow by around 76% between 2025 and 2050, driven mainly by solar photovoltaics.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_indium_recycling_summary',
    defaultMessage:
      'The indium in your touchscreen is technically recoverable, and pilot processes exist. But no large-scale operation is running anywhere. Most screens are incinerated rather than recycled. Leading specialty metals recyclers report that recovering indium is often not economically viable because it is dispersed in thin-film applications. Expert reports on recycling of critical minerals call for much more attention from industry and policymakers.',
  },
  recyclingInputText: {
    id: 'rm_metal_indium_recycling_input_text',
    defaultMessage:
      'Near zero. No recycled indium currently enters the market from end-of-life products.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_indium_recycling_outlook_text',
    defaultMessage:
      'No recycling system exists at scale for indium. The problem is simple: there is so little indium per device, spread so thinly across the screen, that collecting and recovering it costs more than it is worth. Without a major shift in policy or a sharp price increase, the indium in your screen will never be recovered.',
  },
  footnote1Text1: {
    id: 'rm_metal_indium_footnote_1_p1',
    defaultMessage:
      'For co-product metals, the data refer to production at the refining stage. For indium, “Top Mining Countries” should be understood as “Top Refining Countries”, because indium is recovered as a by-product of zinc smelting.',
  },
  mine0Region: {
    id: 'rm_metal_indium_mine0_region',
    defaultMessage: 'Zhuzhou',
  },
  mine1Region: {
    id: 'rm_metal_indium_mine1_region',
    defaultMessage: 'Ulsan',
  },
  mine2Region: {
    id: 'rm_metal_indium_mine2_region',
    defaultMessage: 'Trail',
  },
  mine3Region: {
    id: 'rm_metal_indium_mine3_region',
    defaultMessage: 'Kosaka',
  },
} as const
